// Copyright (c) 2017, Shellyl_N and Authors
// license: ISC
// https://github.com/shellyln
export class WordWrap {
    static loose(str, charsPerLine = 120) {
        let r = "";
        let i = 0;
        for (const c of str) {
            i++;
            if (i >= charsPerLine && " \f\t\v".indexOf(c) > -1) {
                r += "\n";
                i = 0;
            }
            else {
                r += c;
            }
        }
        return r;
    }
    static normal(str, charsPerLine = 120) {
        // TODO: not implemented.
        //       do normal word-wrap.
        return WordWrap.loose(str, charsPerLine);
    }
    static force(str, charsPerLine = 120) {
        // TODO: not implemented.
        //       do break-word word-wrap.
        return WordWrap.loose(str, charsPerLine);
    }
}
//# sourceMappingURL=WordWrap.js.map